// extracted by mini-css-extract-plugin
module.exports = {"ComparativeTableContainer":"SurveyPreviewContainer_ComparativeTableContainer__3mRDN"};